<div id="ht">
    <div id="main-cnt">

        <ion-header class="main-header block">
            <ion-toolbar class="blues-nav">
                <ion-buttons slot="start" class="nav-content">
                    <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span><ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
                        <span class="breadcrumb">News</span>
                    </div>
                </ion-buttons>
            </ion-toolbar>
            <br>

            <!-- edit da qui... -->

            <!-- ...a qui -->
        </ion-header>

        <ion-content class="main-content overflow-auto ">
          <!--  <ion-grid>
                <ion-row>
                    <div class="content vertical-middle middle">
                        <img class="main-logo svg-white max-width-50" src="./assets/imgs/logo-blu.svg">
                        <h3 class="text-center">Coming Soon</h3>
                    </div>
                </ion-row>
            </ion-grid>-->

            <div class="wrapper">
                <div class="content ">
                   <!-- <img class="main-logo svg-white max-width-50" src="./assets/imgs/logo-blu.svg">
                    <h3 class="text-center">Coming Soon</h3>-->
                </div>
            </div>

            <app-coming-soon></app-coming-soon>
        </ion-content>
    </div>
</div>
